import React from 'react';
import { profileData } from '../data';

import './../index.css';
import { ReactComponent as ArrowIcon } from './../assets/icons/ArrowIcon.svg';
import profilePicture from './../assets/images/profilepicture.jpg';
import { LuSend } from 'react-icons/lu';
import { FaGithub } from 'react-icons/fa';

const Hero = () => {
  const work_availability = profileData.profile.work_availability;

  const handleSectionClick = (event) => {
    const targetId = event.currentTarget.hash.slice(1);
    const target = document.getElementById(targetId);

    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
    window.history.replaceState(
      null,
      '',
      `${window.location.pathname}#${targetId}`,
    );
  };

  return (
    <section
      id="hero"
      className="flex flex-col justify-between pt-5 my-16 section-padding lg:my-28 2xl:my-44 md:flex-row text-midground"
    >
      <div className="content-end md:w-3/5 lg:w-1/2">
        <div>
          <ul className="pt-2 h-7">
            {work_availability && (
              <li className="flex items-center space-x-3">
                <div className="relative flex items-center justify-center">
                  {/* Outer Pulsing Glow */}
                  <div className="absolute h-2 w-2 rounded-full bg-emerald-500/60 blur-sm animate-[pulse_3s_ease-in-out_infinite]" />
                  {/* Core Dot with Matching Pulse */}
                  <div className="relative h-2 w-2 rounded-full bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.8)] animate-[pulse_3s_ease-in-out_infinite]" />
                </div>
                <span className="text-sm font-medium text-primary">
                  Open to work
                </span>
              </li>
            )}
          </ul>
          <h1 className="my-7 text-8xl ml-[-5px] 2xl:text-9xl tracking-tight">
            Hello!
          </h1>
          <h2 className="text-4xl 2xl:text-5xl">
            I&apos;m {profileData.profile.first_name}.
          </h2>
        </div>
        <div className="pl-4 mt-10 mb-8 sm:mb-12 2xl:mb-16 2xl:mt-12 2xl:text-xl">
          <ul className="space-y-3 list-disc list-outside md:space-y-1">
            <li>Full-Stack Software Developer</li>
            <li>M.Sc. Graduate in Information Technology</li>
            <li>Located in Oslo, Norway</li>
          </ul>
        </div>
        {/* Contact me & View My Projects Buttons */}
        <div className="flex flex-row flex-wrap items-end justify-start gap-4 mb-3 text-sm sm:mb-0 2xl:text-base lg:mb-3 2xl:mb-10">
          <a
            href="/#projects"
            onClick={handleSectionClick}
            className="relative flex items-center justify-center px-4 py-2 gradient-button-2 group"
          >
            <span>View my projects</span>
            <div className="relative w-5 h-5 ml-1 overflow-hidden">
              <div className="absolute transition-all duration-200 group-hover:-translate-y-5 group-hover:translate-x-4">
                <ArrowIcon className="w-5 h-5" />
                <ArrowIcon className="w-5 h-5 -translate-x-4" />
              </div>
            </div>
          </a>
          <a
            href="/#contact"
            onClick={handleSectionClick}
            className="relative flex items-center justify-center px-4 py-2 gradient-button-2 group"
          >
            <span>Contact me</span>
            <div className="relative w-4 h-4 ml-2 overflow-hidden">
              <div className="absolute transition-all duration-200 group-hover:-translate-y-4 group-hover:translate-x-3">
                <LuSend className="w-4 h-4" />
                <LuSend className="w-4 h-4 -translate-x-3" />
              </div>
            </div>
          </a>
          <a
            href={profileData.socials.github}
            onClick={handleSectionClick}
            className="relative flex items-center justify-center px-2 py-2 gradient-button-2 group"
          >
            <div className="relative overflow-hidden">
              <div className="duration-200 group-hover:-translate-y-5">
                <FaGithub className="w-5 h-5 translate-y-0 transition group-hover:-translate-y-[150%]" />
                <FaGithub className="w-5 h-5 absolute translate-y-[150%] transition group-hover:translate-y-0" />
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="flex items-center justify-center w-full pt-10 md:pt-0 md:justify-end md:items-end md:w-2/5 lg:w-1/2">
        <img
          className="object-cover w-full h-auto overflow-hidden rounded-2xl md:ml-10 md:h-full ring-1 ring-black"
          src={profilePicture}
          alt={profileData.profile.full_name}
        />
      </div>
    </section>
  );
};

export default Hero;
